import { useGetPressReleaseDetailQuery } from '@/api/sanity/generated';
import { sanityLanguage } from '@/constants/language';
import { PressReleaseDetail } from '@/types/pressRelease';
import { serialize } from 'next-mdx-remote/serialize';

export async function getPressReleaseDetail(slug: string): Promise<PressReleaseDetail | null> {
	const fetchPressReleaseDetail = useGetPressReleaseDetailQuery.fetcher({
		slug,
		i18nLang: sanityLanguage,
	});

	const pressReleaseDetail = await fetchPressReleaseDetail();

	if (!pressReleaseDetail.allPressRelease?.[0]) {
		return null;
	}

	return {
		...pressReleaseDetail.allPressRelease[0],
		textMarkdown: await serialize(pressReleaseDetail.allPressRelease[0].text || ''),
	} as PressReleaseDetail;
}
